export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              有影片需求或合作建议？欢迎与我们取得联系
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 mx-auto mb-4">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">商务合作</h3>
                <span className="text-sm text-foreground-600">bd@kuaikanys.com</span>
              </div>

              <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-50 mx-auto mb-4">
                  <i className="ri-film-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">内容投稿</h3>
                <span className="text-sm text-foreground-600">content@kuaikanys.com</span>
              </div>

              <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-50 mx-auto mb-4">
                  <i className="ri-question-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">问题反馈</h3>
                <span className="text-sm text-foreground-600">help@kuaikanys.com</span>
              </div>
            </div>

            <div className="mt-6 bg-background-100 rounded-xl p-8 border border-background-200/70 text-center">
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们的运营团队会在<strong className="text-foreground-950">24小时内</strong>回复你的邮件。
                也欢迎通过站内信与我们交流，共同打造更好的<strong className="text-foreground-950">免费电影在线观看</strong>平台。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}